import { render } from "./CadastrarUsusario.vue?vue&type=template&id=15ee49ff&scoped=true"
import script from "./CadastrarUsusario.vue?vue&type=script&lang=js"
export * from "./CadastrarUsusario.vue?vue&type=script&lang=js"

import "./CadastrarUsusario.vue?vue&type=style&index=0&id=15ee49ff&scoped=true&lang=css"

import exportComponent from "I:\\Centrion\\projetos\\aut_fri_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15ee49ff"]])

export default __exports__